import React from 'react'

import { LayerChangeIcon } from '../../changeIcon'
import { describeChanges, describeOnlyIn } from '../../describeChange'
import { LayerChange } from '../../layerTypes'
import * as Styled from './ChangesPanel.styles'

/** What a layer's change amounts to, in one line. */
const describeLayer = (change: LayerChange) =>
  change.kind !== 'modified'
    ? describeOnlyIn(change.kind)
    : describeChanges(change.changes)

interface LayerRowProps {
  change: LayerChange
  isSelected: boolean
  /** It is only in the version the canvas is not showing. */
  isFromComparedVersion: boolean
  onSelect(): void
}

/**
 * One changed layer, wherever it is listed.
 *
 * The same row whether it sits under the frame that holds it or in the group
 * for the layers that belong to no frame at all - a change is the same thing to
 * point at and click either way.
 */
export function LayerRow({
  change,
  isSelected,
  isFromComparedVersion,
  onSelect,
}: LayerRowProps) {
  return (
    <Styled.ChangeButton
      type="button"
      $nested
      $selected={isSelected}
      $compared={isFromComparedVersion}
      aria-pressed={isSelected}
      onClick={onSelect}
    >
      <Styled.RowIcon
        aria-hidden
        $selected={isSelected}
        $compared={isFromComparedVersion}
      >
        <LayerChangeIcon change={change} />
      </Styled.RowIcon>
      <Styled.Text>
        <Styled.Name $selected={isSelected} $compared={isFromComparedVersion}>
          {change.name || 'Untitled'}
        </Styled.Name>
        <Styled.What>{describeLayer(change)}</Styled.What>
      </Styled.Text>
    </Styled.ChangeButton>
  )
}
